import { useState, useCallback, useEffect } from 'react';
import '@/App.css';
import IntroScreen from './components/IntroScreen';
import BootScreen from './components/BootScreen';
import Desktop from './components/Desktop';
import { useSound } from './hooks/useSound';
import { Analytics } from '@vercel/analytics/react';

// phase: 'intro' → 'booting' → 'desktop'
function App() {
  const [phase, setPhase] = useState('intro');
  const [hasInteracted, setHasInteracted] = useState(false);
  const { playSound } = useSound();

  const handleIntroContinue = useCallback(() => {
    setPhase('booting');
  }, []);

  const handleBootComplete = useCallback(() => {
    setPhase('desktop');
  }, []);

  const handleFirstInteraction = useCallback(() => {
    if (!hasInteracted) {
      setHasInteracted(true);
    }
  }, [hasInteracted]);

  // Listen for first user interaction to enable audio
  useEffect(() => {
    window.addEventListener('click', handleFirstInteraction, { once: true });
    window.addEventListener('keydown', handleFirstInteraction, { once: true });
    return () => {
      window.removeEventListener('click', handleFirstInteraction);
      window.removeEventListener('keydown', handleFirstInteraction);
    };
  }, [handleFirstInteraction]);

  return (
    <div className="App xp-app" data-testid="xp-app">
      {phase === 'intro'    && <IntroScreen onContinue={handleIntroContinue} />}
      {phase === 'booting'  && <BootScreen onBootComplete={handleBootComplete} playSound={playSound} />}
      {phase === 'desktop'  && <Desktop playSound={playSound} />}
      <Analytics />
    </div>
  );
}

export default App;
